<era-devices-unavailable-badge-ui [count]="count$ | async"></era-devices-unavailable-badge-ui>